module.exports = __webpack_public_path__ + "static/sm-3b1c9fb5c651a0bda66739b990a1456d.svg";